import React from 'react';

function MyEducations(){
    return(
        <section id='education'>
            <h2>Education</h2>
            <div className='edu-cards'>
                <article className='edu-card'>
                    <h3>College/University</h3>
                    <div className='edu-row'>
                        <span className='edu-label'><span className='edu-icon' aria-hidden='true'>🎓</span>Degree</span>
                        <span className='edu-value'>Bachelor of Arts in English Literature</span> 
                    </div>
                    <div className='edu-row'>
                        <span className='edu-label'><span className='edu-icon' aria-hidden='true'>🏫</span>Institution</span>
                        <span className='edu-value edu-institution'>Periyar University, Salem</span> 
                    </div>
                    <div className='edu-row'>
                        <span className='edu-label'><span className='edu-icon' aria-hidden='true'>📅</span>Year</span> 
                        <span className='edu-value'>2021-2025</span> 
                    </div>
                </article>
                <article className='edu-card'>
                    <h3>Course</h3>
                    <div className='edu-row'>
                        <span className='edu-label'><span className='edu-icon' aria-hidden='true'>🎓</span>Program</span>
                        <span className='edu-value'>Full Stack Web Development</span> 
                    </div>
                    <div className='edu-row'>
                        <span className='edu-label'><span className='edu-icon' aria-hidden='true'>🏫</span>Institute</span>
                        <span className='edu-value edu-institution'>Besant Technologies, Chennai</span> 
                    </div>
                    <div className='edu-row'>
                        <span className='edu-label'><span className='edu-icon' aria-hidden='true'>📅</span>Certificate ID</span>
                        <span className='edu-value'>125185</span> 
                    </div>
                </article>
            </div>            
        </section>
    )
}
export default MyEducations;
